  // Product tab click handler
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.product-tab-list a');
    if (!link) return;

    // Prevent default only for tab links
    e.preventDefault();

    const productTab = link.closest('.product-tab');
    if (!productTab) return;

    const hrefId = link.getAttribute('href');

    productTab.querySelectorAll('a').forEach((a) => a.classList.remove('active'));
    productTab.querySelectorAll('.tab-panal').forEach((panel) => panel.classList.remove('active'));

    link.classList.add('active');

    const targetPanel = document.querySelector(hrefId);
    if (targetPanel) targetPanel.classList.add('active');
  });
  if (window.matchMedia("(max-width: 991px)").matches) {
    const tabClick = document.querySelectorAll('.product-tab .accordion summary');
    tabClick.forEach(tab => {
      tab.click();

      tab.addEventListener("click", function (e) {
        const activeTab = document.querySelectorAll('.product-tab .accordion details[open]');
        activeTab.forEach(active => {
          active.querySelector('summary').click();
        });
      });
    });
  }

  const accordions = document.querySelectorAll(".accordion");

  


document.addEventListener('DOMContentLoaded', () => {
  const addBtns = document.querySelectorAll('.template-product [data-add-btn]');

  addBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      // Always re-select CTA (Shopify replaces DOM)
      let mainCTA = document.querySelector('.product__info-wrapper .product-form__buttons .product-form__submit');

      if (!mainCTA) return;

     // 👉 Scroll smoothly to main CTA
    mainCTA.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

      // Trigger click after scroll
      setTimeout(() => {
        mainCTA.click();
      }, 400);
    });
  });
});
